<template>
  <BaseDialog
    :showCondition="showCondition"
    @closed="$emit('closed')"
  >
    <template v-slot:title>
      <span class="primary--text">تعديل الملف الشخصي</span>
    </template>

    <template v-slot:body>
      <v-form ref="form">
        <v-container>
          <v-row justify="center">
            <v-col align="center" cols="9">
              <BaseTextField
                v-model="name"
                label="الاسم"
                placeholder="الاسم"
                name="الاسم"
                :rules="[nameRule]"
              ></BaseTextField>

              <BaseTextField
                v-model="email"
                label="البريد الالكتروني"
                placeholder="البريد الالكتروني"
                name="البريد الالكتروني"
                :rules="[emailRule]"
              ></BaseTextField>

              <BaseTextField
                v-model="phoneNumber"
                label="رقم الهاتف المحمول"
                placeholder="رقم هاتف محمول مفعل عليه الواتساب"
                name="رقم الهاتف المحمول"
                type="number"
                :rules="[phoneNumberRule]"
              ></BaseTextField>

              <BaseTextField
                v-model="studyField"
                label="مجال الدراسة"
                placeholder="مجال الدراسة"
                name="مجال الدراسة"
                :rules="[studyFieldRule]"
              ></BaseTextField>

              <v-autocomplete
                v-model="relatedFieldIds"
                chips
                clearable
                item-value="id"
                :items="jobFields"
                :filter="customFilter"
                label="مجالات تهتم بها"
                hint="من أجل تجربة أفضل في عرض فرص العمل مخصصة يمكنك إدخال مجالات تهتم بها"
                persistent-hint
                outlined
                multiple
              >
                <template v-slot:item="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:selection="{ item }">
                  <v-chip>{{ item.name }}</v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </template>

    <template v-slot:actions>
      <v-row justify="center">
        <v-col align="center">
          <v-btn
            @click="validateThenUpdateProfile()"
            class="accent rounded-pill px-10 mt-5"
          >
            حفظ التعديلات
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/core/base/dialogs/BaseDialog.vue";
import { mapState, mapActions } from "pinia";
import { useProfileStore } from "../store/ProfileStore";
import { useJobOpportunitiesStore } from "@/modules/job_opportunities/store/JobOpportunitiesStore";
import { Notify } from "@/core/classes/notify/Notify";

export default {
  props: {
    showCondition: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      name: "",
      email: "",
      phoneNumber: "",
      studyField: "",
      relatedFieldIds: [],
    };
  },
  components: { BaseDialog },
  computed: {
    ...mapState(useProfileStore, ["profile"]),
    ...mapState(useJobOpportunitiesStore, ["jobFields"]),
  },
  watch: {
    showCondition(newVal) {
      if (newVal && this.profile) {
        this.initializeForm();
      }
    },
  },
  mounted() {
    if (this.jobFields.length == 0) {
      this.fetchJobFields()
        .then()
        .catch((err) => console.error(err));
    }
    if (this.profile) {
      this.initializeForm();
    }
  },
  methods: {
    customFilter(field, queryText) {
      const fieldText = field.name.toLowerCase();
      const searchText = queryText.toLowerCase();
      return fieldText.indexOf(searchText) > -1;
    },
    ...mapActions(useProfileStore, ["updateProfile"]),
    ...mapActions(useJobOpportunitiesStore, ["fetchJobFields"]),
    initializeForm() {
      this.name = this.profile.name || "";
      this.email = this.profile.email || "";
      this.phoneNumber = this.profile.phoneNumber || "";
      this.studyField = this.profile.studyField || "";
      this.relatedFieldIds = this.profile.interestedFields.map(
        (field) => field.id
      );
    },
    validateThenUpdateProfile() {
      if (this.$refs.form.validate()) {
        const updateData = {};
        
        if (this.name && this.name !== this.profile.name) {
          updateData.name = this.name;
        }
        if (this.email && this.email !== this.profile.email) {
          updateData.email = this.email;
        }
        if (this.phoneNumber && this.phoneNumber !== this.profile.phoneNumber) {
          updateData.phone_number = this.phoneNumber;
        }
        if (this.studyField && this.studyField !== this.profile.studyField) {
          updateData.study_field = this.studyField;
        }
        
        const currentFieldIds = this.profile.interestedFields.map(f => f.id);
        const fieldsChanged = JSON.stringify(this.relatedFieldIds.sort()) !== JSON.stringify(currentFieldIds.sort());
        
        if (fieldsChanged) {
          updateData.fields_ids = this.relatedFieldIds;
        }

        if (Object.keys(updateData).length === 0) {
          Notify.showMessage("info", "لم يتم إجراء أي تغييرات");
          this.$emit("closed");
          return;
        }

        this.updateProfile(updateData)
          .then(() => {
            Notify.showMessage("success", "تم تحديث الملف الشخصي بنجاح");
            this.$emit("closed");
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
};
</script>

<style scoped></style>
